
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M9 17V7l8 5-8 5zm3-15C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z","id":"path-1"}})]),_c('g',{attrs:{"id":"UPDATES","stroke":"none","stroke-width":"1","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Release_notes","transform":"translate(-1222 -269)"}},[_c('g',{attrs:{"id":"Group","transform":"translate(1220 267)"}},[_c('use',{attrs:{"id":"↳-Color","xlink:href":"#path-1"}})])])])])
          )
        }
      }
    